import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Login } from 'react-admin';
import CircularProgress from '@material-ui/core/CircularProgress';
import { IconButton, Button, Dialog, DialogContent, DialogActions } from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { useHistory, useLocation } from "react-router-dom";
// import config from './config.json'
import notify from './components/CustomUseNotify';
import { useLogin } from 'ra-core';
import config from './config.json';
import CustomOtpInput from './components/CustomOtpInput';
// import Logo from "./images/login_logo.png";
import { customTheme } from "./customTheme";
import CustomImageSlider from './components/CustomImageSlider';
import facebook from './images/facebookIcon.png'
import twitter from './images/twitterIcon.png'
import instagram from './images/instagramIcon.png'
import linkedin from './images/linkedinIcon.png'
import youtube from './images/youtubeIcon.png'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import club125 from './images/club125.jpg'
import aiims from './images/aiims.jpg'
import ats from './images/ats.jpeg'
import sector18 from './images/sector18.jpg'
import Whatsapp from './components/Whatsapp';
import Call from './components/Call';
import md5 from 'md5';
import { passwordSalt } from "./sharedData";
import c1 from './images/c1.png'
import c2 from './images/c2.png'
import c3 from './images/c3.png'
import c4 from './images/c4.png'
import c5 from './images/c5.png'
import c6 from './images/c6.png'
import c7 from './images/c7.png'
import c8 from './images/c8.png'
import c9 from './images/c9.png'
import c10 from './images/c10.png'
import c11 from './images/c11.png'
import c12 from './images/c12.png'
import PSBLogo from './images/ps_business_logo.svg';

const parkSmartBusiness = [
    { image: '', type: "video", text: "Check out our corporate solution" },
    { image: aiims, type: "image", text: " Check out our Hospital solution"},
    { image: ats, type: "image", text: "Check out our Society solution" },
    { image: sector18, type: "image", text: "Check out our Parking solution" },
    { image: club125, type: "image", text: "Check out our Mall solution" },
]

const clients = [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12]
// const RECAPTCHA_KEY_V3 = '6LdvnD0nAAAAAMi83XoTGK-uLtrmTFjsg_SPuCef'

const useStyles = makeStyles(theme => ({
    main: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center'
    },
})
);
const USERNAME = 'USERNAME'
const MOBILE = 'MOBILE'

const DASHBOARD_SEND_OTP_RECAPTCHA_ACTION = 'dashboard_send_otp'
const DASHBOARD_RESEND_OTP_RECAPTCHA_ACTION = 'dashboard_resend_otp'
const DASHBOARD_RESET_PASSWORD_OTP_RECAPTCHA_ACTION = 'dashboard_send_otp'
const NEW_DASHBOARD_URL = 'https://parksmart.io/web/auth/login'

const LoginForm = props => {

    const { redirectTo } = props;
    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const login = useLogin();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [loginWith, setLoginWith] = useState(USERNAME);
    const [mobileNumber, setMobileNumber] = useState("");
    const [messageId, setMessageId] = useState(null);
    const [otp, setOtp] = useState("");
    const [counter, setCounter] = useState(0);
    const [retryLoading , setRetryLoading] = useState(false);
    const [newDashboardDialogVisible, setNewDashboardDialogVisible] = useState(false);

    const [resetPassword, setResetPassword] = useState(false);
    const [resetInput, setResetInput] = useState("")
    const [resetOtp, setResetOtp] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [resetMessageId, setResetMessageId] = useState("")

    const usernameHandler = () => {
            if (userName == null || userName === '') {
                notify('Username is required', 'warning')
                return;
            }
    
            if (password == null || password === '') {
                notify('Password is required', 'warning')
                return;
            }
            setLoading(true);
            login({loginWith: USERNAME, username: userName, password }, redirectTo)
                .then((res) => {
                    setLoading(false);
                    if (typeof res.data.redirect_after_login === "string" && res.data.redirect_after_login !== "") {
                        history.push(res.data.redirect_after_login);
                    } else if (res.data.role === "contractor" && res.data.hide_parking_section === 1) {
                        if (res.data.show_rfid)
                            history.push(`/permitLogs`);
                        else if (res.data.show_parking_analytics)
                            history.push(`/parkingAnalytics`);
                        else if (res.data.show_parking_controllers)
                            history.push(`/parkingControllers`);
                        else
                            history.push(`/parkingCameras`);
                    } else if (res.data.hide_parking_section === 0) {
                        history.push('/parkings')
                    } else {
                        history.push('/societiesparking')
                    }
                })
                .catch(error => {
                    setLoading(false);
                    notify(
                        typeof error === 'string'
                            ? error
                            : typeof error === 'undefined' || !error.message
                                ? 'ra.auth.sign_in_error'
                                : error.message,
                        'warning'
                    );
                });
    };

    const mobileNumberHandler = () => {
        
        if (!new RegExp("^[0-9]{4}$").test(otp)) {
            notify('Invalid Otp format', 'warning')
            return;
        }

        if (messageId == null || messageId === '') {
            notify('Invalid request', 'warning')
            return;
        }

        setLoading(true);
        login({ loginWith: MOBILE, mobile_number: mobileNumber, otp: otp, message_id: messageId }, redirectTo)
            .then((res) => {
                setLoading(false);
                if (typeof res.data.redirect_after_login === "string" && res.data.redirect_after_login !== "") {
                    history.push(res.data.redirect_after_login);
                } else if (res.data.role === "contractor" && res.data.hide_parking_section === 1) {
                    if (res.data.show_rfid)
                        history.push(`/permitLogs`);
                    else if (res.data.show_parking_analytics)
                        history.push(`/parkingAnalytics`);
                    else if (res.data.show_parking_controllers)
                        history.push(`/parkingControllers`);
                    else
                        history.push(`/parkingCameras`);
                } else if (res.data.hide_parking_section === 0) {
                    history.push('/parkings')
                } else {
                    history.push('/societiesparking')
                }
            })
            .catch(error => {
                setLoading(false);
                notify(
                    typeof error === 'string'
                        ? error
                        : typeof error === 'undefined' || !error.message
                            ? 'ra.auth.sign_in_error'
                            : error.message,
                    'warning'
                );
            });
    };

    const sendOtp = (recaptcha_token) =>{
        if (!new RegExp("^[0-9]{10}$").test(mobileNumber)) {
            notify('Invalid Mobile Number', 'warning')
            return;
        }
        setLoading(true);
        fetch(`${config.HOST_NAME}/dashboard/auth/sendOtp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ mobile_number: mobileNumber, recaptcha_token })
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    setMessageId(json.data.messageId)
                } else notify(json.message, 'warning')
            })
            .catch(error => {
                console.log(error);
                notify("Something Went Wrong", 'warning')
            }).finally(() => {
                setLoading(false);
            })
    }

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    }

    const onClickHandler = async () => {
        if (loginWith === USERNAME) usernameHandler()
        if (loginWith === MOBILE) {
            if (!messageId) {
                if (!executeRecaptcha) return console.log('Execute recaptcha not yet available');
                const token = await executeRecaptcha(DASHBOARD_SEND_OTP_RECAPTCHA_ACTION);
                if (!token) return notify("Captcha Validation is Required", "error")
                // const isReCaptchaVerified = await verifyRecaptcha(token)
                // if (!isReCaptchaVerified.success) {
                //     notify(isReCaptchaVerified.message, "error");
                //     return
                // }
                sendOtp(token)
            }
            else mobileNumberHandler()
        }
    }

    const retryHandler = async () => {
        
        if (!executeRecaptcha) return console.log('Execute recaptcha not yet available');

        const token = await executeRecaptcha(DASHBOARD_RESEND_OTP_RECAPTCHA_ACTION);
        if (!token) return notify("Captcha Validation is Required", "error")

        const params = { mobile_number: mobileNumber, message_id: messageId, recaptcha_token: token };

        setRetryLoading(true)
        fetch(`${config.HOST_NAME}/dashboard/auth/resendOtp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        })
            .then(response => response.json())
            .then(json => {
                if (json.success) {
                    notify(json.message, 'success')
                    setCounter(30)
                } else notify(json.message, 'warning')
                
            })
            .catch(error => {
                console.log(error);
                notify("Something Went Wrong", 'warning')
            }).finally(() => {
                setRetryLoading(false);
            })
    }

    const sendResetPasswordOtp = (recaptcha_token) =>{
        const params = {recaptcha_token}
        if(resetInput === "" || resetInput === null){
            notify('Email or Mobile is required', 'warning')
            return
        }
        else if (new RegExp("^[0-9]{10}$").test(resetInput)) {
            params.mobile_number = resetInput
            // params.requestWith = "MOBILE"
        }
        else if (new RegExp(/\S+@\S+\.\S+/).test(resetInput)) {
            params.email = resetInput
            // params.requestWith = "EMAIL"
        }
        else {
            notify('Invalid Email or Mobile', 'warning')
            return
        }

        setLoading(true);
        fetch(`${config.HOST_NAME}/dashboard/auth/initPasswordReset`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    setResetMessageId(json.data.messageId)
                    // setUserDetails(json.data.user_details)
                    // setResetPasswordWith(json.data.user_details.email && json.data.user_details.mobile_number ? "OTP has been delivered to your email and mobile." : params.mobile_number ? "OTP has been delivered to your mobile." : params.email ? "OTP has been delivered to your email." : null)
                    notify("OTP has been delivered to your Email Address or Mobile Number", 'success')
                } else notify(json.message, 'warning')
            })
            .catch(error => {
                console.log(error);
                notify("Something Went Wrong", 'warning')
            }).finally(() => {
                setLoading(false);
            })
    }

    const verifyOtpHandler = () =>{
        const params = {}
        params.message_id = resetMessageId
        params.otp = resetOtp

        if (new RegExp("^[0-9]{10}$").test(resetInput)) params.mobile_number = resetInput
        else if (new RegExp(/\S+@\S+\.\S+/).test(resetInput)) params.email = resetInput

        if(newPassword === "" || newPassword === null){
            notify('New password is required', 'warning')
            return
        }
        if(newPassword.length < 6){
            notify('Minimum 6 character limit', 'warning')
            return
        }
        if(newPassword.length > 15){
            notify('Maximum 15 character limit', 'warning')
            return
        }

        if(newPassword !== confirmPassword){
            notify('Confirm password not matched', 'warning')
            return
        }

        params.new_password =  md5(newPassword + passwordSalt)

        setLoading(true);
        fetch(`${config.HOST_NAME}/dashboard/auth/verifyPasswordReset`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({...params})
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    notify("Your password has been updated successfully", 'success')
                    resetFormStates()
                }
                else notify(json.message, 'warning')
            })
            .catch(error => {
                console.log(error);
                notify("Something Went Wrong", 'warning')
            }).finally(() => {
                setLoading(false);
            })
    }

    // const newPasswordHandler = () =>{
    //     const params = {}
        
    //     if(newPassword === "" || newPassword === null){
    //         notify('New password is required', 'warning')
    //         return
    //     }
    //     if(newPassword.length < 6){
    //         notify('Minimum 6 character limit', 'warning')
    //         return
    //     }
    //     if(newPassword.length > 15){
    //         notify('Maximum 15 character limit', 'warning')
    //         return
    //     }

    //     if(newPassword !== confirmPassword){
    //         notify('Confirm password not matched', 'warning')
    //         return
    //     }

    //     params.new_password =  md5(newPassword + passwordSalt)
    //     params.message_id = resetMessageId

    //     setLoading(true);
    //     fetch(`${config.HOST_NAME}/crm/v3/resetPassword`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify({...userDetails, ...params})
    //     }).then(res => res.json())
    //         .then(json => {
    //             if (json.success) {
    //                 notify("Your password has been updated successfully", 'success')
    //                 resetFormStates()
    //             } else notify(json.message, 'warning')
    //         })
    //         .catch(error => {
    //             console.log(error);
    //             notify("Something Went Wrong", 'warning')
    //         }).finally(() => {
    //             setLoading(false);
    //         })
    // }

    const resetPasswordHandler = async () =>{
        if(!resetMessageId){
            //Request for otp
            if (!executeRecaptcha) return console.log('Execute recaptcha not yet available');
            const token = await executeRecaptcha(DASHBOARD_RESET_PASSWORD_OTP_RECAPTCHA_ACTION);
            if (!token) return notify("Captcha Validation is Required", "error")

            sendResetPasswordOtp(token)
        }else if(resetMessageId) {
            verifyOtpHandler()
        }
    }

    const resetFormStates = () => {
        setResetPassword(false)
        setResetInput("")
        setResetOtp("")
        setNewPassword("")
        setConfirmPassword("")
        setResetMessageId("")
    }

    const openNewDashboardDialog = () => {
        setNewDashboardDialogVisible(true)
    }

    const closeNewDashboardDialog = () => {
        setNewDashboardDialogVisible(false)
    }

    const visitNewDashboard = () => {
        window.open(NEW_DASHBOARD_URL, '_blank', 'noopener,noreferrer')
        closeNewDashboardDialog()
    }

    // const verifyRecaptcha = async (token) => {
    //     return new Promise((resolve) => {
    //         fetch(`${config.HOST_NAME}/crm/v3/validateRecaptchaWithGoogle?recaptcha_key=${RECAPTCHA_KEY_V3}&token=${token}&version=${3}`, {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         })
    //             .then(response =>  response.json())
    //             .then((responseJson) => {
    //                 if (responseJson.success) {
    //                     resolve({ success: true })
    //                 } else resolve({ success: false, message: responseJson.message })
    //             })
    //             .catch((e) => {
    //                 console.log(e)
    //                 resolve({ success: false, message: 'Something Went Wrong' })
    //             });
    //     })
    // }

    useEffect(() => {
        const timer =
            counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        return () => clearInterval(timer);
    }, [counter]);

    useEffect(() => {
        const getQueryParam = (param, useWindow = false) => {
            const urlSearchParams = new URLSearchParams(useWindow ? window.location.search : location.search);
            return urlSearchParams.get(param);
        };
        if (getQueryParam('resetPassword') === 'true') setResetPassword(true);
        if (getQueryParam('ref', true) === 'sms') setLoginWith(MOBILE)
    }, [location.search]);

    return (
        <>
            <div className='slides-container'>
                <CustomImageSlider images={parkSmartBusiness} autoSlideInterval={5000} />
                {/* <div className="marquee-container">
                    <div className="marquee">
                       <div>
                       {clients.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Image ${index}`}
                                className="marquee-image"
                            />
                        ))}
                       </div>
                    </div>
                    <div className="marquee">
                    <div>
                       {clients.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Image ${index}`}
                                className="marquee-image"
                            />
                        ))}
                       </div>
                    </div>
                    <div className="marquee">
                    <div>
                       {clients.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Image ${index}`}
                                className="marquee-image"
                            />
                        ))}
                       </div>
                    </div>
                </div> */}
                
                   <div className="marquee-container">
                    <div className="marquee-track">
                       {clients.map((image, index) => (
                        <div className='marquee'>
                            <img
                                key={index}
                                src={image}
                                alt={`marqueeImage ${index}`}
                                className="marquee-image"
                            />
                            </div>
                        ))}
                    </div>

                    <div className="marquee-track">
                       {clients.map((image, index) => (
                        <div className='marquee'>
                            <img
                                key={index}
                                src={image}
                                alt={`marqueeImage ${index}`}
                                className="marquee-image"
                            />
                            </div>
                        ))}
                    </div>

                    {/* <div className="marquee-track">
                       {clients.map((image, index) => (
                        <div className='marquee'>
                            <img 
                                key={index}
                                src={image}
                                alt={`marqueeImage ${index}`}
                                className="marquee-image"
                            />
                            </div>
                        ))}
                    </div> */}
                 
                </div>
            </div>

            <div className='login-form' style={{position:"relative"}}>
                <div
                    className='new-dashboard-badge'
                    onClick={openNewDashboardDialog}
                    role='button'
                    tabIndex={0}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') openNewDashboardDialog()
                    }}
                >
                    <span className='new-dashboard-badge-label'>New</span>
                    <span className='new-dashboard-badge-text'>Dashboard</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={PSBLogo} alt='logo' style={{ width: 130 }} />
                </div>

                {/* Signin Form */}
                {!resetPassword &&
                    <div style={{ margin: '15px 0px' }}>
                        <div style={{ color: customTheme.palette.secondary.main, fontSize: 19, textAlign: 'center', fontWeight: "bold" }}>Sign in to dashboard</div>

                        {loginWith === USERNAME &&
                            <>
                                <div style={{ color: "#707683", fontSize: 14, fontWeight: 'bold', marginTop: 15, marginBottom: 6 }}>Username</div>
                                <div className='login_input_container'>
                                    <input className='login_input'
                                        type="text"
                                        value={userName}
                                        onChange={(e) => setUserName(e.target.value)}
                                        placeholder='Type your username'
                                    />
                                </div>

                                <div style={{ color: "#707683", fontSize: 14, fontWeight: 'bold', marginTop: 15, marginBottom: 6 }}>Password</div>
                                <div className='login_input_container'>
                                    <input className='login_input'
                                        type={passwordVisible ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder='Type your password'
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') onClickHandler()
                                        }}
                                    />
                                    <IconButton onClick={togglePasswordVisibility} size='small'>
                                        {passwordVisible ?
                                            <VisibilityIcon fontSize='small' />
                                            :
                                            <VisibilityOffIcon fontSize='small' />
                                        }
                                    </IconButton>
                                </div>
                            </>
                        }

                        {loginWith === MOBILE &&
                            <>
                                <div style={{ color: "#707683", fontSize: 14, fontWeight: 'bold', marginTop: 15, marginBottom: 6 }}>Mobile Number</div>
                                <div className='login_input_container'>
                                    <input className='login_input'
                                        type="text"
                                        value={mobileNumber}
                                        onChange={(e) => setMobileNumber(e.target.value)}
                                        placeholder='Type your mobile number'
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') onClickHandler()
                                        }}
                                    />
                                </div>

                                {messageId && <div style={{ color: "#707683", fontSize: 14, fontWeight: 'bold', marginTop: 15, marginBottom: 6 }}>OTP</div>}
                                {messageId && <CustomOtpInput value={otp} valueLength={4} onChange={(val) => setOtp(val)} />}
                            </>

                        }

                        {loginWith === MOBILE && messageId &&
                            <p style={{ fontSize: 13, color: "#707683", textAlign: "right", marginTop: 10 }}>Didn't get the code? {counter !== 0 ? <span style={{ color: "#707683" }}>Wait for {counter}</span> : <span style={{ fontWeight: "bold", color: "#109CF1", cursor: "pointer" }} onClick={retryHandler}>Resend {retryLoading && <CircularProgress size="0.5rem" sx={{ marginLeft: "10px" }} thickness={6}></CircularProgress>}</span>}</p>
                        }

                        {loginWith === USERNAME &&
                            <p style={{ fontSize: 13, color: "#109CF1", cursor: "pointer", textAlign: "right", marginTop: 10, fontWeight: 'bold' }} onClick={() => setResetPassword(true)}>Forgot Password?</p>
                        }
                        <div style={{ display: "flex", alignItems: "center", gap: 20, marginTop: 15 }}>
                            <Button
                                onClick={onClickHandler}
                                color="primary"
                                variant="contained"
                                style={{ textTransform: "none", fontSize: 14, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", backgroundColor: "#18CC69", color: "#FFF", width: '100%', padding: "10px 20px", borderRadius: 5 }}
                                disableElevation
                                disabled={loading}
                            >
                                Login
                                {loading && <CircularProgress size={18} style={{ color: "#FFF", marginLeft: 10 }} />}
                            </Button>
                        </div>

                        <p className='or'>OR</p>

                        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                            <Button
                                onClick={() => setLoginWith(loginWith === USERNAME ? MOBILE : USERNAME)}
                                color="primary"
                                variant="outlined"
                                style={{ textTransform: "none", fontSize: 14, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", color: "#707683", border: "1px solid #707683", width: '100%', padding: "10px 20px", borderRadius: 5 }}
                                disableElevation
                                disabled={loading}
                            >
                                {loginWith === USERNAME ? 'Login with OTP' : 'Login with Username'}
                            </Button>
                        </div>
                    </div>
                }

                {/* Reset Password Form */}
                {resetPassword &&
                    <div style={{ margin: '15px 0px' }}>
                        <div style={{ color: customTheme.palette.secondary.main, fontSize: 19, textAlign: 'center', fontWeight: "bold" }}>Reset your password</div>
                        {!resetMessageId &&
                            <>
                                <div style={{ color: "#707683", fontSize: 14, fontWeight: 'bold', marginTop: 15, marginBottom: 6 }}>Email or Mobile</div>
                                <div className='login_input_container'>
                                    <input className='login_input'
                                        type="text"
                                        value={resetInput}
                                        onChange={(e) => setResetInput(e.target.value)}
                                        placeholder='Type your email or mobile number'
                                    />
                                </div>
                            </>
                        }

                        {resetMessageId &&
                            <>
                                <>
                                    <div style={{ color: "#707683", fontSize: 14, fontWeight: 'bold', marginTop: 15, marginBottom: 6 }}>New Password</div>
                                    <div className='login_input_container'>
                                        <input className='login_input'
                                            type={passwordVisible ? "text" : "password"}
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            placeholder='Type your password'
                                        />
                                        <IconButton onClick={togglePasswordVisibility} size='small'>
                                            {passwordVisible ?
                                                <VisibilityIcon fontSize='small' />
                                                :
                                                <VisibilityOffIcon fontSize='small' />
                                            }
                                        </IconButton>
                                    </div>

                                    <div style={{ color: "#707683", fontSize: 14, fontWeight: 'bold', marginTop: 15, marginBottom: 6 }}>Confirm Password</div>
                                    <div className='login_input_container'>
                                        <input className='login_input'
                                            type={passwordVisible ? "text" : "password"}
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            placeholder='Type your password'
                                        />
                                        <IconButton onClick={togglePasswordVisibility} size='small'>
                                            {passwordVisible ?
                                                <VisibilityIcon fontSize='small' />
                                                :
                                                <VisibilityOffIcon fontSize='small' />
                                            }
                                        </IconButton>
                                    </div>
                                </>
                                <div style={{ color: "#707683", fontSize: 14, fontWeight: 'bold', marginTop: 15, marginBottom: 6 }}>OTP Verification</div>
                                <CustomOtpInput value={resetOtp} valueLength={4} onChange={(val) => setResetOtp(val)} />
                            </>
                        }

                        <div style={{ display: "flex", alignItems: "center", gap: 20, marginTop: 25 }}>
                            <Button
                                onClick={resetPasswordHandler}
                                color="primary"
                                variant="contained"
                                style={{ textTransform: "none", fontSize: 14, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", backgroundColor: "#18CC69", color: "#FFF", width: '100%', padding: "10px 20px", borderRadius: 5 }}
                                disableElevation
                                disabled={loading}
                            >
                                {!resetMessageId ? 'Next' : 'Reset'}
                                {loading && <CircularProgress size={18} style={{ color: "#FFF", marginLeft: 10 }} />}
                            </Button>
                        </div>
                    </div>
                }
                
                {resetPassword && <div style={{ color: "#707683", textAlign: 'center', fontSize: 13, fontWeight: 'bold', marginTop: 20 }}>Get back to <span style={{ color: '#109CF1', cursor:'pointer' }} onClick={() => resetFormStates()}>Login</span></div>}

                {/* <p style={{ color: "#707683", textAlign: 'center', fontSize: 13, fontWeight: 'bold', lineHeight: '1px' }}>Don't have an account? <span style={{ color: '#109CF1' }}>Sign Up</span></p> */}

            </div>

            <Dialog
                fullWidth
                open={newDashboardDialogVisible}
                onClose={closeNewDashboardDialog}
                PaperProps={{ style: { maxWidth: 470, borderRadius: 18, padding: 0, overflow: "hidden" } }}
            >
                <DialogContent style={{ padding: "0" }}>
                    <div style={{ background: "linear-gradient(135deg, #E8FFF1 0%, #F6FFF9 100%)", padding: "24px 26px 18px 26px", borderBottom: "1px solid #E6EEF2" }}>
                        <div style={{ display: "inline-flex", alignItems: "center", padding: "5px 10px", borderRadius: 999, backgroundColor: "#18CC691A", color: "#0D8F49", fontSize: 11, fontWeight: "bold", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 12 }}>
                            New Update
                        </div>
                        <div style={{ color: customTheme.palette.secondary.main, fontSize: 24, fontWeight: 800, lineHeight: "30px", marginBottom: 8 }}>
                            A Better Dashboard Is Ready
                        </div>
                        <div style={{ color: "#51606D", fontSize: 14, lineHeight: "23px" }}>
                            We have launched a new dashboard experience built to be faster, cleaner, and more user-friendly for your daily operations.
                        </div>
                    </div>
                    <div style={{ padding: "20px 26px 10px 26px" }}>
                        <div style={{ color: "#334D6E", fontSize: 15, fontWeight: "bold", marginBottom: 8 }}>
                            Migration reminder
                        </div>
                        <div style={{ color: "#4F5B67", fontSize: 14, lineHeight: "24px", marginBottom: 12 }}>
                            If your site has not been migrated yet, please reach out to your site handler as soon as possible and complete the migration at the earliest.
                        </div>
                        <div style={{ color: "#7B8794", fontSize: 13, lineHeight: "22px" }}>
                            After migration, you can continue using the new dashboard from the link below.
                        </div>
                    </div>
                </DialogContent>
                <DialogActions style={{ padding: "6px 26px 22px 26px", justifyContent: "space-between" }}>
                    <Button
                        onClick={closeNewDashboardDialog}
                        variant='outlined'
                        style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", color: "#5B6770", border: "1px solid #D7DDE4", padding: "6px 14px", borderRadius: 8, minWidth: 84 }}
                        disableElevation
                    >
                        Close
                    </Button>
                    <Button
                        onClick={visitNewDashboard}
                        variant='contained'
                        style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", backgroundColor: "#18CC69", color: "#FFF", padding: "6px 14px", borderRadius: 8, minWidth: 154 }}
                        disableElevation
                    >
                        Visit New Dashboard
                    </Button>
                </DialogActions>
            </Dialog>
        </>

    )
}

const SocialMediaLinks = () => (
<div className='login-social-links'>
                <a href="https://www.linkedin.com/company/parksmarthq/" target="_blank" rel="noreferrer">
                    <img src={linkedin} width={45} alt="linkedin" />
                </a>
                <a href="https://www.instagram.com/parksmarthq/" target="_blank" rel="noreferrer">
                    <img src={instagram} width={45} alt="instagram" />
                </a>
                <a href="https://www.facebook.com/ParkSmartHQ" target="_blank" rel="noreferrer">
                    <img src={facebook} width={45} alt="facebook" />
                </a>
                <a href="https://twitter.com/parksmarthq/" target="_blank" rel="noreferrer">
                    <img src={twitter} width={45} alt="twiiter" />
                </a>
                <a href="https://www.youtube.com/@parksmarthq" target="_blank" rel="noreferrer">
                    <img src={youtube} width={45} alt="youtube" />
                </a>

            </div>
)

const CustomLoginPage = (props) => {
    const classes = useStyles(props);
    return (
        <div>
            <Login
                {...props}
                classes={classes}
                id='custom-login-page'
            >
                <LoginForm />
            </Login>
            <SocialMediaLinks/>
            <Whatsapp />
            {/* <Call /> */}
        </div>

    );
};
export default CustomLoginPage;
